<template>
  <div class="container-fluid">
    <div class="card-body">
      <b-card>
        <div class="d-flex justify-content-between">
          <div>
            <h5 class="card-title align-items-start flex-column mb-2">
              <span class="card-label font-weight-bolder text-dark">
                Cliente:
              </span>
              <span class="card-label text-dark">
                {{ cliente.nome }}
              </span>
            </h5>
            <h5 class="card-title align-items-start flex-column mb-2">
              <span class="card-label font-weight-bolder text-dark">
                Valor da OS:
              </span>
              <span class="card-label text-dark">
                R$ {{ numberToReal(ordemServico.valorTotal, 2) }}
              </span>
            </h5>
            <h5 class="card-title align-items-start flex-column mb-20">
              <span class="card-label font-weight-bolder text-dark">
                OS número:
              </span>
              <span class="card-label text-dark">
                {{ ordemServico.numero }}
              </span>
            </h5>
          </div>
          <div>
            <button
              @click="goBackToOSList"
              class="text-primary font-weight-bolder h6"
            >
              Voltar
            </button>
          </div>
        </div>

        <vue-timeline-update
          v-for="item of timelineItems"
          :key="item.name"
          :date="new Date(item.date)"
          :description="`${item.label} em ${$moment(item.date).format(
            'DD/MM/YYYY'
          )} as ${item.time} ${
            item.label === 'Respondido'
              ? `, Contato: ${item.contato} ${
                  item.observacao ? '- ' + item.observacao : ''
                }`
              : ''
          } `"
          :category="item.name"
          :color="item.color"
          icon="code"
        />
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import { mask } from "vue-the-mask";

export default {
  name: "app-os-timeline",
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin],
  directives: {
    mask,
  },
  data() {
    return {
      timelineItems: [],
      cliente: {},
      ordemServico: {},
    };
  },
  computed: {
    ...mapGetters(["pageTitle", "layoutConfig"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    goBackToOSList() {
      this.$router.push({ name: "ordensServicos" });
    },
    addTimelineItem(timeline, field, item) {
      if (!timeline[field]) {
        return;
      }

      const [date, time] = timeline[field].split(" ");

      this.timelineItems.push({
        ...item,
        date,
        time,
      });
    },
    async getInit() {
      const { id_ordem_servico } = this.$route.params;
      this.$http
        .post("/ordemservico/timeline", {
          id_ordem_servico,
        })
        .then(({ data }) => {
          const timeline = data.timeline;
          this.cliente = data.cliente;
          this.ordemServico = data.ordemServico;
          this.addTimelineItem(timeline, "dataAlteracao", {
            name: "Resposta do cliente",
            label: "Respondido",
            color: "turquoise",
            contato: timeline.contato,
            observacao: timeline.observacaoCliente,
            status: timeline.status,
          });
          this.addTimelineItem(timeline, "dataEnvioLink", {
            name: "Envio de link",
            label: "Enviado",
            color: "green",
          });
          this.addTimelineItem(timeline, "dataVisualizacao", {
            name: "Visualização",
            label: "Cliente visualizou",
            color: "orange",
          });
          this.timelineItems.sort((a, b) => {
            if (a.date === b.date) {
              return a.time < b.time ? -1 : 1;
            }

            return a.date < b.date ? -1 : 1;
          });
          this.setLoading(false);
        })
        .catch((error) => {
          this.setLoading(false);
          this.$toast.error(`Erro ao buscar timeline da OS:\n${error}`);
        });
    },
  },
  async created() {
    this.setLoading(true);
    this.getInit();
  },
};
</script>
<style scoped>
svg {
  outline-width: 0;
  outline-color: transparent;
  color: rgb(241, 249, 255);
}

.container {
  background-color: white;
  margin-top: 20px;
  border-radius: 10px;
  padding: 3rem;
  box-shadow: 0px 0px 30px 0px rgba(82, 63, 105, 0.05);
}

.select-city .vs__search::placeholder,
.select-city .vs__dropdown-toggle,
.select-city .vs__dropdown-menu {
  height: 10rem !important;
  background-color: green !important;
}

.contato-input {
  height: 3rem;
}
</style>
